import _ from 'lodash';
import { createSelector } from 'reselect';

import CustomerSubscriptionsSelector from './CustomerSubscriptionsSelector';

const subscriptionsList = state => CustomerSubscriptionsSelector(state);

const getActiveSubscriptions = mySubscriptionsList => {
  if (mySubscriptionsList.error) {
    return { error: mySubscriptionsList.error };
  }
  if (mySubscriptionsList.status === 'loading') {
    return { status: mySubscriptionsList.status };
  }

  // filter out any subscription object that does not
  // have a status of active or trialing
  const activeSubscriptions = _.filter(mySubscriptionsList.data, subscription => {
    return subscription.status === 'active' || subscription.status === 'trialing';
  });

  if (process.env.NODE_ENV !== 'production') {
    console.log('ActiveSubscriptionsSelector subscriptions', activeSubscriptions);
  }

  return { data: activeSubscriptions[0] };
};

export default createSelector(
  // state selecting functions which are updated
  // whenever the global state changes
  subscriptionsList,
  // function containing selector logic
  getActiveSubscriptions
);



// WEBPACK FOOTER //
// ./src/selectors/ActiveSubscriptionsSelector.js